<script>
    import UserAccess from "./UserAccess/UserAccessTable.svelte";
    import TokenTable from "./Token/TokenTable.svelte";
    import { currentUser } from "../stores";
</script>

{#if $currentUser.hasAdminPermissions}
    <UserAccess />
{/if}

{#if $currentUser.hasOpenApiAccess}
    <TokenTable />
{/if}
